import { Expose } from "class-transformer";
import type { IProductHistory } from "../../../interfaces/IProductHistory";

export interface ISearchHistoryDto {
  history: IProductHistory[];
}

export class SearchHistoryDto implements ISearchHistoryDto {
  @Expose()
  history!: IProductHistory[];

  constructor(history?: IProductHistory[]) {
    if (history) {
      this.history = history;
    }
  }
}
